import React from 'react'
import './BackDrop.css'

export default function BackDrop(props){
    return(
        <div className='backdrop-container'>
            {props.children}
        </div>
    )
}